import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const TituloFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TITULO' htmlFor='input-titulo' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='titulo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-titulo'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloFormGroup)
